// extracted by mini-css-extract-plugin
module.exports = {"legal":"terms-and-conditions_legal__WiGCl","hideLinks":"terms-and-conditions_hideLinks__9R4WP","paragraph":"terms-and-conditions_paragraph__LJ4Ic"};